/**
 * Reserve right-click for game gestures across the whole browser game window.
 *
 * Capture phase reaches events before whichever canvas, gump, HUD, or modal is
 * under the pointer. Only the browser default is cancelled, so target and bubble
 * handlers still receive the event for game-specific behavior.
 */
export function installContextMenuGuard(target: EventTarget): () => void {
  const suppress = (event: Event): void => event.preventDefault();
  target.addEventListener('contextmenu', suppress, { capture: true });
  return () => target.removeEventListener('contextmenu', suppress, { capture: true });
}
